function escapeHtml(text) {
  const div = document.createElement("div")
  div.textContent = text
  return div.innerHTML
}

export function showConfirmDialog({ message, title, confirmLabel, cancelLabel }) {
  return new Promise((resolve) => {
    const overlay = document.createElement("div")
    overlay.className = "fixed inset-0 z-50 overflow-y-auto"
    overlay.setAttribute("role", "dialog")
    overlay.setAttribute("aria-modal", "true")

    overlay.innerHTML = `
      <div class="fixed inset-0 bg-gray-500/75 transition-opacity" data-role="backdrop"></div>
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative bg-white rounded-lg shadow-xl max-w-sm w-full transform transition-all">
          <div class="p-6">
            <div class="flex items-start">
              <div class="shrink-0 flex items-center justify-center h-10 w-10 rounded-full bg-blue-100">
                <svg class="h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 00-1.883 2.542l.857 6a2.25 2.25 0 002.227 1.932H19.05a2.25 2.25 0 002.227-1.932l.857-6a2.25 2.25 0 00-1.883-2.542m-16.5 0V6A2.25 2.25 0 016 3.75h3.879a1.5 1.5 0 011.06.44l2.122 2.12a1.5 1.5 0 001.06.44H18A2.25 2.25 0 0120.25 9v.776" />
                </svg>
              </div>
              <div class="ml-4">
                <h3 class="text-base font-semibold text-gray-900">${escapeHtml(title)}</h3>
                <p class="mt-1 text-sm text-gray-600">${escapeHtml(message)}</p>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-6 py-3 flex justify-end space-x-3 rounded-b-lg">
            ${cancelLabel ? `<button type="button" data-role="cancel" class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-xs hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-green-500">${escapeHtml(cancelLabel)}</button>` : ""}
            <button type="button" data-role="confirm" class="px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md shadow-xs hover:bg-green-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-green-500">${escapeHtml(confirmLabel)}</button>
          </div>
        </div>
      </div>
    `

    const cleanup = (result) => {
      document.removeEventListener("keydown", handleKeydown)
      overlay.remove()
      resolve(result)
    }

    const handleKeydown = (e) => {
      if (e.key === "Escape") cleanup(false)
    }

    if (cancelLabel) {
      overlay.querySelector("[data-role='cancel']").addEventListener("click", () => cleanup(false))
    }
    overlay.querySelector("[data-role='confirm']").addEventListener("click", () => cleanup(true))
    overlay.querySelector("[data-role='backdrop']").addEventListener("click", () => cleanup(false))
    document.addEventListener("keydown", handleKeydown)

    document.body.appendChild(overlay)
    overlay.querySelector("[data-role='confirm']").focus()
  })
}

export function showAlert(message, { title = "", confirmLabel = "OK" } = {}) {
  return showConfirmDialog({ message, title, confirmLabel, cancelLabel: null })
}

export function reloadFolderSection(moveUrl) {
  // Handle both document_folders/:id/move and document_files/:id/move URLs
  const indexUrl = moveUrl.replace(/\/document_(folders|files)\/[^/]+\/move$/, "")
  const sectionFrame = document.querySelector("turbo-frame[id^='document_folders_']")
  if (!sectionFrame) return

  // Capture expanded folder IDs before reload
  // NOTE: Use getAttribute/setAttribute instead of dataset API because the
  // Stimulus namespace separator "--" in "document-folders--folder" doesn't
  // round-trip correctly through dataset (dataset converts it to a single dash).
  const EXPANDED_ATTR = "data-document-folders--folder-expanded-value"
  const FOLDER_ID_ATTR = "data-document-folders--folder-folder-id-value"

  const expandedFolderIds = new Set(
    Array.from(sectionFrame.querySelectorAll(`[${EXPANDED_ATTR}='true']`))
      .map((el) => el.getAttribute(FOLDER_ID_ATTR))
      .filter(Boolean),
  )

  if (expandedFolderIds.size > 0) {
    const restoreState = () => {
      expandedFolderIds.forEach((folderId) => {
        const folderEl = sectionFrame.querySelector(`[${FOLDER_ID_ATTR}="${folderId}"]`)
        if (folderEl) {
          folderEl.setAttribute(EXPANDED_ATTR, "true")
          expandedFolderIds.delete(folderId)
        }
      })

      if (expandedFolderIds.size === 0) {
        cleanup()
      }
    }

    const cleanup = () => {
      sectionFrame.removeEventListener("turbo:frame-load", restoreState)
      clearTimeout(safetyTimeout)
    }

    sectionFrame.addEventListener("turbo:frame-load", restoreState)
    const safetyTimeout = setTimeout(cleanup, 5000)
  }

  sectionFrame.src = indexUrl
}
